import { render, staticRenderFns } from "./StudioGiftClaim.vue?vue&type=template&id=18239a8a&scoped=true&"
import script from "./StudioGiftClaim.vue?vue&type=script&lang=ts&"
export * from "./StudioGiftClaim.vue?vue&type=script&lang=ts&"
import style0 from "./StudioGiftClaim.vue?vue&type=style&index=0&id=18239a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18239a8a",
  null
  
)

export default component.exports